// extracted by mini-css-extract-plugin
export default {"commissionContainer":"styles_commissionContainer__gW+Hm","title":"styles_title__aeRGw","headerText":"styles_headerText__caRC0","seperatorMargin":"styles_seperatorMargin__AhgkA"};